import { createContext, FC, useState } from "react";
import DocumentsList from "./DocumentsList";
import { UploadDocumentContextType } from "./types";

export const UploadDocumentContext = createContext<UploadDocumentContextType>({
    setRefetch:()=>{},
    refetch:true
})

const UploadDocuments:FC<{files?:string,submission?:boolean}> = ({files="image/*,application/pdf,video/*",submission=false})=>{
    const [refetch,setRefetch] = useState<boolean>(true)
    return (
        <UploadDocumentContext.Provider value={{refetch,setRefetch}}>
        <div className="p-2">
           <DocumentsList files={files} submission={submission}/>
        </div> 
        </UploadDocumentContext.Provider>
    )
}

export default UploadDocuments

